export const NotificationQcFieldName = 'notificationQcFieldComponent';
